import axios from "axios";
import Cookies from "js-cookie";

const token = Cookies.get("authToken")
const headers = {
    Authorization: `Bearer ${token}`,
  }
const url ="https:"+window.process.env.API_HOST_GLOBAL;

export const SendAccess = async (path, sessionId, action) => {
    try {
      return await axios.post(`${url}${path}`, {
        EmpStatsQuery:{
          session_id: sessionId,
          action: action,
        }
   
      },{headers});
    } catch (e) {
      console.error("ERROR Send access :", e);
    }
  };